import { render } from "./About.vue?vue&type=template&id=b422747e"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=b422747e&lang=css"

import exportComponent from "/Users/matjeez/Matjez/Projects/websites/simonkr-feb24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__